import React from "react";
import { IPlacedOrder, stateStylings } from "../constants";
import Styles from "../../../scss/orderDetails.module.scss";
import { useTranslation } from "react-i18next";


interface IOrderStatusProps {
    placed_order: IPlacedOrder;
}

export function OrderStatusDetails({ placed_order }: IOrderStatusProps) {
    const { t } = useTranslation();
    return <div>
        <div>
            <p className={Styles.label}>{t('orderHistory.modal.idStatus')}</p>
        </div>
        <div data-component-name="OrderDetailsOrderID">
            <p >{placed_order?.placed_order_hash_id}</p>
            <span style={stateStylings[placed_order.placed_order_order_status || "DEFAULT"] || stateStylings["DEFAULT"]}>
                {t(`orderTypes.${placed_order.placed_order_order_status?.toLowerCase()}`)}
            </span>
        </div>
    </div>
}